<template>
  <div id="app">
    <router-view></router-view>
    <audio ref="myAudio" class="bacAudio" :src="audioUrl" autoplay loop controls></audio>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      audioUrl: require('./assets/bacmusic.mp3')
    }
  },
  mounted () {
    this.$nextTick(() => {
      document.getElementsByClassName('bacAudio')[0].play();
      document.addEventListener("WeixinJSBridgeReady", function () {
        document.getElementsByClassName('bacAudio')[0].play();
      });
      // document.addEventListener('visibilitychange', function () {
      //   if (document.visibilityState === 'hidden') {
      //     console.log('隐藏了')
      //     console.log(document.visibilityState)
      //     document.getElementsByClassName('bacAudio')[0].pause()
      //   } else {
      //     console.log('显示了')
      //     console.log(document.visibilityState)
      //     document.getElementsByClassName('bacAudio')[0].play()
      //   }
      // });
    })
    window.ydk.onPageVisibilityChange({
      success: function(res){
        if(res.hidden){
          document.getElementsByClassName('bacAudio')[0].pause()
        } else{
          document.getElementsByClassName('bacAudio')[0].play()
        }
      }
    });

  }
}
</script>

<style>
html,body{
  margin: 0;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: -20;
  -webkit-user-select: none;
}
#app{
  width: 100%;
  height: 100%;
  position: relative;
  color: #504e4a;
  z-index: -20;
  margin: 0 auto;
  min-height: 12.06rem;
}
.bacAudio{
  position: fixed;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  visibility: hidden;
}
</style>
